export default __webpack_public_path__ + "static/media/main-characters-padded-lg-2x.db8ab4ed.jpg";